import { Link, useLocation, useSearchParams } from 'react-router';
import { FOCUSRING } from '../focus';

export interface WeekLinkProps {
  /** De week waar de lezer naartoe gaat. */
  week: string;
  /** De tekst van de link — één hele zin uit `qa.*`, met de week erin. */
  label: string;
  'data-testid': string;
  /** Wat voor weg terug dit is, voor een toets die de twee uit elkaar moet houden. */
  'data-werkkwaliteit-terugweg'?: string;
}

/**
 * De weg naar een andere week, in één vorm.
 *
 * Twee plekken bieden hem aan en zij horen er hetzelfde uit te zien en zich hetzelfde te gedragen:
 * de storingsmelding (story 4.6) en de beoordelaarsstrook bij "te weinig gegevens" — waar
 * `EXPERIENCE.md` (*State Patterns*) diezelfde link vraagt en tot 4 september 2026 alleen de zin
 * stond.
 *
 * **Alleen de week verandert.** Het uitgeklapte veld (`?veld=…`) en alles wat er later bij komt gaan
 * mee; zonder dat verliest de weg terug stilletjes waar de lezer stond. Het pad blijft dat van de
 * weergave waarin de link staat, zodat een manager op het persoonsdetail van een collega daar
 * terugkomt en niet op zijn eigen week.
 */
export function WeekLink({ week, label, ...markering }: WeekLinkProps) {
  const { pathname } = useLocation();
  const [zoekwaarden] = useSearchParams();
  const adres = new URLSearchParams(zoekwaarden);
  adres.set('week', week);

  return (
    <Link
      className={`rounded-[4px] text-[var(--foreground-heading)] underline underline-offset-2 ${FOCUSRING}`}
      to={`${pathname}?${adres.toString()}`}
      {...markering}
    >
      {label}
    </Link>
  );
}
